import type { AxiosResponse } from 'axios'
import type { PaginationParams } from 'types'

export enum ActionType {
  UPLOAD_CSV_TAG_FILE = 'UPLOAD_CSV_TAG_FILE',
}

export type UploadTagsFileFields = {
  file: File
}
